import {inject, Injectable} from '@angular/core';
import Swal, {SweetAlertOptions, SweetAlertResult} from 'sweetalert2';
import {TranslateService} from "@ngx-translate/core";

export const SWEET_ALERT_CONFIG = {
  options: {
    timerProgressBar: false,
    focusConfirm: false,
    focusDeny: false,
    focusCancel: false,
    returnFocus: false,
    buttonsStyling: true,
    customClass: {
      confirmButton: 'btn btn-primary rounded',
      denyButton: 'btn btn-danger rounded',
      cancelButton: 'btn text-white rounded',
    },
  }
};


@Injectable({
  providedIn: 'root'
})
/**
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
export class SweetAlertService {
  private translateService = inject(TranslateService);

  // private _defaultOptions: SweetAlertGlobalOptions = Object.assign(SWEET_ALERT_CONFIG, this._config);

  get defaultOptions(): SweetAlertOptions {
    return SWEET_ALERT_CONFIG.options;
  }

  //<editor-fold desc="Public Methods">
  public success(options: SweetAlertOptions = {}): Promise<SweetAlertResult> {
    return this.simpleAlert({
      ...{
        text: this.translateService.instant('ALERT.SUCCESS'),
        icon: 'success',
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 1500,
      },
      ...options
    });
  }

  public error(options: SweetAlertOptions = {}): Promise<SweetAlertResult> {
    return this.simpleAlert({
      ...{icon: 'error'},
      ...options
    });
  }

  public warning(options: SweetAlertOptions = {}): Promise<SweetAlertResult> {
    return this.simpleAlert({
      ...{icon: 'warning'},
      ...options
    });
  }

  public info(options: SweetAlertOptions = {}): Promise<SweetAlertResult> {
    return this.simpleAlert({
      ...{icon: 'info'},
      ...options
    });
  }

  public confirm(options: SweetAlertOptions = {}): Promise<SweetAlertResult> {
    return new Promise<SweetAlertResult>((resolve, reject) => {

      const confirmOptions: SweetAlertOptions = {
        ...this.defaultOptions as any,
        ...{
          title: this.translateService.instant('ALERT.CONFIRM_TITLE'),
          text: this.translateService.instant('ALERT.CONFIRM_TEXT'),
          icon: 'question',
          showCancelButton: true,
          showConfirmButton: true,
        },
        ...options
      }

      this.simpleAlert(confirmOptions)
        .then((result: SweetAlertResult) => {
          if (result.isConfirmed) {
            resolve(result);
          } else {
            reject(result);
          }
        })
        .catch(reason => {
          reject(reason);
        })
      ;
    })
  }

  public fire(options: SweetAlertOptions) {
    return Swal.fire(options);
  }

  //</editor-fold>

  private simpleAlert(options: SweetAlertOptions): Promise<SweetAlertResult> {

    return this.fire({
      ...this.defaultOptions as any,
      ...{
        text: this.translateService.instant('ALERT.ERROR'),
        confirmButtonText: this.translateService.instant('ALERT.DEFAULT_CONFIRM_BUTTON_TEXT'),
        cancelButtonText: this.translateService.instant('ALERT.DEFAULT_CANCEL_BUTTON_TEXT'),
      },
      ...options
    });
  }

}
